module.exports = __webpack_public_path__ + "staticV3/img/d99eea54.empty-address.png";